import _ from 'underscore';
import { View } from 'backbone';
import template from './template.pug';

export class StatusPopupView extends View {
  events() {
    return {
      'click .statuschangelink': this.onClick,
    };
  }

  /**
   * initialize view settings
   *
   * @param {Object} param - An object containing these default options for view:
   * @param {Object} param.statusOptions - status options to be shown in view
   *   it should be an array of { name, value } objects
   *   value is the value to be returned to user when status updated
   *   name is the one to be used to generate text & icon style based, in the format of
   *     text/title: search by key EntityStatus_$(name)
   *     iconClass: status$(name)_icon
   *     textClass: status$(name)
   * @param {Object} param.currentStatus - currentStatus, related to the {value} in statusOptions
   * @param {Object} param.i18n - the localization settings, by default return the provided key
   * @returns {void} void
  */
  initialize({
    statusOptions = [{ name: 'Enabled', value: 'Active' }, { name: 'Paused', value: 'UserPaused' }],
    currentStatus,
    i18n,
  }) {
    this.options = {
      items: this.getItemsForRender(statusOptions, i18n),
      i18n,
      currentStatus,
    };
    super.initialize(this.options);
    this.currentStatus = currentStatus;
  }

  /**
   * initialize status setting for rendering
   *
   * @param {Array} statusOptions - status options to be shown in view
   *   it should be an array of { name, value } objects
   *   value is the value to be returned to user when status updated
   *   name is the one to be used to generate text & icon style based, in the format of
   *     text/title: search by key EntityStatus_$(name)
   *     iconClass: status$(name)_icon
   *     textClass: status$(name)
   * @param {Object} i18n - the localization settings, by default return the provided key
   * @returns {Array} items for rendering, which includes
   *  {text, title, iconClass, textClass, value} got based on name & value of statusOptions
  */
  getItemsForRender(statusOptions, i18n) {
    return _.map((statusOptions), (option) => {
      const iconClassPrefix = `status${option.name}`;

      return {
        title: i18n.getString(`EntityStatus_${option.name}`),
        text: i18n.getString(`EntityStatus_${option.name}`),
        iconClass: option.iconClass || `${iconClassPrefix}_icon`,
        textClass: iconClassPrefix,
        value: option.value || option.name,
        ariaLabel: i18n.getString(`EntityStatus_AriaLabel_${option.name}`),
      };
    });
  }

  render() {
    this.$el.html(template(this.options));

    return this;
  }

  setFocus() {
    this.$(`.clickable[data-value="${this.currentStatus}"]`).focus();
  }

  onClick(event) {
    this.trigger('close', event.currentTarget.dataset.value);
  }
}
